import { defineComponent as i, openBlock as o, createElementBlock as e, mergeProps as u, unref as a, renderSlot as m, createElementVNode as n, createCommentVNode as h } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, f = { key: 1 }, V = { key: 2 }, k = { key: 3 }, v = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconChatTeardrop"
}, _ = /* @__PURE__ */ i({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: l } = g(s);
    return (p, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      m(p.$slots, "default"),
      a(l) === "bold" ? (o(), e("g", Z, t[0] || (t[0] = [
        n("path", { d: "M132,20A104.11,104.11,0,0,0,28,124v84a20,20,0,0,0,20,20h84a104,104,0,0,0,0-208Zm0,184H52V124a80,80,0,1,1,80,80Z" }, null, -1)
      ]))) : a(l) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M224,124h0a92,92,0,0,1-92,92H48a8,8,0,0,1-8-8V124a92,92,0,0,1,92-92h0A92,92,0,0,1,224,124Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M132,24A100.11,100.11,0,0,0,32,124v84a16,16,0,0,0,16,16h84a100,100,0,0,0,0-200Zm0,184H48V124a84,84,0,1,1,84,84Z" }, null, -1)
      ]))) : a(l) === "fill" ? (o(), e("g", V, t[2] || (t[2] = [
        n("path", { d: "M232,124A100.11,100.11,0,0,1,132,224H48a16,16,0,0,1-16-16V124a100,100,0,0,1,200,0Z" }, null, -1)
      ]))) : a(l) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        n("path", { d: "M132,26a98.11,98.11,0,0,0-98,98v84a14,14,0,0,0,14,14h84a98,98,0,0,0,0-196Zm0,184H48a2,2,0,0,1-2-2V124a86,86,0,1,1,86,86Z" }, null, -1)
      ]))) : a(l) === "regular" ? (o(), e("g", v, t[4] || (t[4] = [
        n("path", { d: "M132,24A100.11,100.11,0,0,0,32,124v84a16,16,0,0,0,16,16h84a100,100,0,0,0,0-200Zm0,184H48V124a84,84,0,1,1,84,84Z" }, null, -1)
      ]))) : a(l) === "thin" ? (o(), e("g", w, t[5] || (t[5] = [
        n("path", { d: "M132,28a96.11,96.11,0,0,0-96,96v84a12,12,0,0,0,12,12h84a96,96,0,0,0,0-192Zm0,184H48a4,4,0,0,1-4-4V124a88,88,0,1,1,88,88Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  _ as default
};
